export const css = {
	root: 'aCCM0MV4',
	' _key': 'ascm-theme/ascm/variants/cscp2024'
};

export default css;
